import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createCar } from "../../api/car";
import { listDevices } from "../../api/device";
import { uploadFile } from "../../api/file";
import { Device } from "../../types/api";

const prefixes = ["นาย", "นาง", "นางสาว"];

export default function CarCreatePage() {
  const [form, setForm] = useState({
    plateNumber: "",
    prefix: "",
    firstName: "",
    lastName: "",
    imagePath: "",
    deviceId: 0,
  });
  const [devices, setDevices] = useState<Device[]>([]);
  const [preview, setPreview] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const navigate = useNavigate();

  const handleChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSelectFile = (file: File) => {
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      let imageUrl = form.imagePath;

      // ✅ upload จริงเฉพาะตอนกด save
      if (selectedFile) {
        const url = await uploadFile(selectedFile);
        imageUrl = url;
      }

      await createCar({ ...form, imagePath: imageUrl });
      navigate("/cars");
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  useEffect(() => {
    const loadDevices = async () => {
      const { list } = await listDevices();
      const available = list.filter((d: any) => !d.isUsed);
      setDevices(available);
    };
    loadDevices();
  }, []);

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        เพิ่มรถใหม่
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={6}>
              <TextField
                fullWidth
                label="หมายเลขรถ / เลขทะเบียนรถ"
                value={form.plateNumber}
                onChange={(e) => handleChange("plateNumber", e.target.value)}
              />
            </Grid>

            <Grid size={6}>
              <TextField
                fullWidth
                select
                label="GPS Device (Box Id)"
                value={form.deviceId || ""}
                onChange={(e) =>
                  handleChange("deviceId", Number(e.target.value))
                }
              >
                <MenuItem value="">-- เลือก GPS --</MenuItem>
                {devices.map((d) => (
                  <MenuItem key={d.id} value={d.id}>
                    {d.boxId} {d.simNumber ? `(${d.simNumber})` : ""}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid size={2}>
              <TextField
                fullWidth
                select
                label="คำนำหน้า"
                value={form.prefix}
                onChange={(e) => handleChange("prefix", e.target.value)}
              >
                {prefixes.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid size={5}>
              <TextField
                fullWidth
                label="ชื่อ"
                value={form.firstName}
                onChange={(e) => handleChange("firstName", e.target.value)}
              />
            </Grid>

            <Grid size={5}>
              <TextField
                fullWidth
                label="นามสกุล"
                value={form.lastName}
                onChange={(e) => handleChange("lastName", e.target.value)}
              />
            </Grid>

            {/* ✅ Upload Preview (ยังไม่อัปโหลดจริง) */}
            {/* <Grid size={12}>
              <Box
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const file = e.dataTransfer.files?.[0];
                  if (file) handleSelectFile(file);
                }}
                onClick={() =>
                  document.getElementById("image-upload-input")?.click()
                }
                sx={{
                  border: "2px dashed #bbb",
                  borderRadius: 2,
                  textAlign: "center",
                  py: 4,
                  cursor: "pointer",
                  backgroundColor: "#fafafa",
                  "&:hover": { backgroundColor: "#fffde7" },
                }}
              >
                {preview ? (
                  <Box
                    component="img"
                    src={preview}
                    alt="preview"
                    sx={{
                      width: 160,
                      height: 160,
                      borderRadius: 2,
                      objectFit: "cover",
                      border: "1px solid #ccc",
                    }}
                  />
                ) : (
                  <>
                    <Typography variant="body1" color="text.secondary">
                      คลิกหรือลากรูปมาวางที่นี่
                    </Typography>
                    <Typography variant="body2" color="text.disabled">
                      รองรับไฟล์ .jpg, .png
                    </Typography>
                  </>
                )}
                <input
                  id="image-upload-input"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) handleSelectFile(file);
                  }}
                />
              </Box>
            </Grid> */}

            <Grid size={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: "#FEDC00", color: "#000" }}
              >
                บันทึก
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
